<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash-es';
import SkistarAddonAccommodations from '../../../components/ski/skistar/SkistarAddonAccommodations';
import SkistarResortSubareaSelect from '../../../components/ski/skistar/SkistarrResortSubareaSelect';
import SkistarResortsSelect from '../../../components/ski/skistar/SkistarResortsSelect';

export default {
  name: 'SkistarResortAddons',
  components: {
    SkistarAddonAccommodations,
    SkistarResortSubareaSelect,
    SkistarResortsSelect,
  },
  data() {
    return {
      headers: [
        { text: 'Id', class: 'px-2', value: 'id' },
        { text: 'Category', class: 'px-2', value: 'addonType' },
        { text: 'Description', class: 'px-2', value: 'description' },
        { text: 'Price Rule', class: 'px-2', value: 'priceRule' },
        { text: 'Used', class: 'px-2 text-xs-center', value: 'accommodationCount' },
        { text: 'Twenty Extra Id', class: 'px-2', value: 'twentyExtraId' },
      ],
      pagination: {
        rowsPerPage: 20,
        sortBy: 'description',
      },
      paginationRowsPerPage: [
        20,
        50,
        { text: 'All', value: -1 },
      ],
    };
  },
  computed: {
    ...mapState({
      addon: state => state.skistar.addons.addon,
      addons: state => state.skistar.addons.items,
      loading: state => state.skistar.addons.itemsLoading,
      resortId: state => state.skistar.resorts.resort,
      updateInProgress: state => state.skistar.addons.updateInProgressItems,
    }),
    ...mapGetters({
      filteredAddons: 'skistar/getAddons',
    }),
  },
  methods: {
    ...mapActions({
      search: 'skistar/searchAddons',
      getResortAddons: 'skistar/getResortAddons',
      updateAddonTwentyExtraId: 'skistar/updateAddonTwentyExtraId',
      showAddonAccommodationModal: 'skistar/showAddonAccommodationModal',
    }),
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    setAddonTwentyExtraId(addon) {
      const updateAddon = {
        id: addon.id,
        description: addon.description,
        priceRule: addon.priceRule,
        addonType: addon.addonType,
        twentyExtraId: addon.twentyExtraId,
      };
      this.updateAddonTwentyExtraId(updateAddon);
    },
    throttleSearch: throttle(function input(search) {
      this.search(search);
    }, 250, { leading: false }),
  },
  mounted() {
    if (this.resortId) {
      this.getResortAddons();
    }
  },
  watch: {
    resortId() {
      this.getResortAddons();
    },
  },
};
</script>

<template>
  <v-card>
    <v-container fluid>
      <v-layout row>
        <v-flex xs3>
          <skistar-resorts-select />
          <skistar-addon-accommodations
            v-if="addon.showAccommodations"
            :id="addon.id"
            :description="addon.description"
            :accommodations="addon.accommodations"
            :show="addon.showAccommodations"
          />
        </v-flex>
        <v-flex xs3 pl-4>
          <skistar-resort-subarea-select />
        </v-flex>
        <v-flex xs6 pl-4>
          <v-text-field
            @input="throttleSearch"
            append-icon="search"
            label="Search"
            clearable
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-data-table
            :items="filteredAddons"
            :headers="headers"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="paginationRowsPerPage"
            no-results-text="No adddons"
            class="print"
            item-key="id"
            must-sort
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  @click="changeSort(header.value)"
                  :key="header.text"
                  :class="['column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.class ? header.class : '',
                      header.align ? 'text-xs-' + header.align : 'text-xs-left'
                    ]"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="px-1">{{ props.item.id }}</td>
                <td class="px-2">{{ props.item.addonType }}</td>
                <td class="px-2">{{ props.item.description }}</td>
                <td class="px-2">{{ props.item.priceRule }}</td>
                <td class="px-2 text-xs-center">
                  <v-btn
                    @click="showAddonAccommodationModal(props.item)"
                    color="primary"
                    round
                    small
                  >
                    {{ props.item.accommodationCount }}
                  </v-btn>
                </td>
                <td class="px-2">
                  <v-text-field
                    v-model="props.item.twentyExtraId"
                    @change="setAddonTwentyExtraId(props.item)"
                    :loading="updateInProgress[props.item.id]"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skistar/SkistarResortAddons.vue